/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { FC, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "@/app/csr-src/models";
import { useTranslation } from "react-i18next";
import { getEnv } from "@/app/csr-src/env";
import { PAY_TYPE } from "@/app/csr-src/apis/checkout/constants/constants";

import UKToast from "@/common-components-src/components/UKToast/index";
import { Button } from "@mui/material";
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import PaypalSvg from "@/assets/icons/pay/Paypal.svg";

import Styles from "./btn.module.scss";

interface PayPalProps {
  toOrderList: () => void; // 支付失败后的回调
  onSubmit: () => any; // 提单
  onLoadingResult: (data: any, closeLoading: () => void) => any;
}
const ERROR_CODE = {
  SUBMIT_ERROR: "Submit order info error",
};

const PayPal: FC<PayPalProps> = observer((props) => {
  const clientId = getEnv().PAYMENT_PAYPAL_CLIENT_ID as string;
  const config = {
    clientId,
    intent: "capture", // captrue or authorize
    currency: "GBP",
  };

  const { t } = useTranslation();

  const { checkoutStore } = useStores();
  const [loading, setLoading] = useState(false);

  // 关闭loading
  const closeLoading = () => {
    setLoading(false);
    checkoutStore.setSafetyLoading(false);
  };

  // 关闭loading,跳转订单列表unpay
  const onPayError = () => {
    UKToast.show({
      content: t("common.message.networkError"), // 弹窗内容
      icon: "error", // 可选：success, fail, loading, warn, info，影响图标
    });
    closeLoading();
    props.toOrderList();
  };

  const handleSubmit = async () => {
    setLoading(true);
    checkoutStore.setSafetyLoading(true);
    const res: any = await props.onSubmit();

    console.log("createOrder paypal response", res);
    const payData = res.data?.payInfo ? JSON.parse(res.data.payInfo) : {};

    if (checkoutStore.isQuickPay && res.success) {
      if (payData?.quickPaymentSuccess) {
        handleQuickPay();
        return;
      }

      onPayError();
      return;
    }

    // eslint-disable-next-line no-async-promise-executor
    return new Promise < string > (async (resolve, reject) => {
      const checkoutId = payData.checkoutId;

      if (!res.success) {
        // 提单失败处理
        closeLoading();
        return reject(ERROR_CODE.SUBMIT_ERROR);
      }

      if (!checkoutId) {
        // 结果返回成功，但没有checkoutId
        // 支付失败处理
        onPayError();
        return reject("Pay info error");
      }
      return resolve(checkoutId);
    });
  };

  // 提单参数

  const onApprove = () => {
    const requestData = {
      txnSeqno: (checkoutStore.payResult as any).id,
      txnScene: "Consumption",
      payMethod: Number(checkoutStore.payMethod),
    };

    return props.onLoadingResult(requestData, closeLoading);
  };

  // 取消支付
  const onCancel = () => {
    closeLoading();
    props.toOrderList();
  };

  const onError = (err: any) => {
    // 提单失败处理
    if (err.toString().includes(ERROR_CODE.SUBMIT_ERROR)) {
      closeLoading();
      return;
    }
    // 支付失败处理
    onPayError();
  };

  // 处理快捷支付之后的逻辑
  const handleQuickPay = () => {
    onApprove();
  };

  useEffect(() => {
    return () => {
      // 获取所有的 script 标签
      const scriptTags = document.getElementsByTagName('script');

      // 遍历所有 script 标签
      for (let i = scriptTags.length - 1; i >= 0; i--) {
        const script = scriptTags[i];
        if (script.src.includes('https://www.paypal.com/sdk/js')) {
          // 如果找到匹配的 script 标签，则将其从父元素中移除
          script.parentNode?.removeChild(script);
        }
      }
    };
  }, []);

  return (
    <>
      <div
        style={{
          display:
            checkoutStore.payMethod === PAY_TYPE.PAYPAL && !checkoutStore.isQuickPay
              ? "block"
              : "none",
          width: "100%",
        }}
      >
        <PayPalScriptProvider options={config}>
          <PayPalButtons
            style={{
              layout: "vertical",
              color: "blue",
              // shape: "pill",
              label: "paypal",
            }}
            createOrder={handleSubmit as any}
            onApprove={onApprove}
            onError={onError}
            onCancel={onCancel}
            fundingSource="paypal"
            disabled={
              loading ||
              checkoutStore.payMethod !== PAY_TYPE.PAYPAL ||
              checkoutStore.submitOrderBtnDisabled
            }
          />
        </PayPalScriptProvider>
      </div>
      <div
        style={{
          display:
            checkoutStore.payMethod === PAY_TYPE.PAYPAL && checkoutStore.isQuickPay
              ? "block"
              : "none",
          width: "100%",
        }}
      >
        <Button
          variant="contained"
          fullWidth
          sx={{
            "&.Mui-disabled": {
              backgroundColor: "#0070ba",
              opacity: 0.3,
            },
          }}
          className={Styles.commonPaypalBtn}
          disabled={checkoutStore.submitOrderBtnDisabled || loading}
          onClick={handleSubmit}
        >
          <PaypalSvg width={63} height={17} />
        </Button>
      </div>
    </>
  );
});

export default PayPal;
